import React from "react";
import { Box } from "@mui/material";

import ResponseListItem from "./ResponseListItem";
import EmptyResult from "components/Shared/Lottie/EmptyResult";

const ResponseList = ({ responses = [], onEditAction = () => {} }) => {
  const _sortedResponses = [...responses]?.sort((a, b) =>
    a?.createdAt > b?.createdAt ? -1 : 1
  );

  return (
    <Box paddingX={3}>
      {!!_sortedResponses?.length ? (
        _sortedResponses?.map((response) => (
          <ResponseListItem
            response={response}
            key={response?._id}
            onEditAction={onEditAction}
          />
        ))
      ) : (
        <EmptyResult height={150} />
      )}
    </Box>
  );
};

export default ResponseList;
